import * as React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Markdown from "react-markdown";
import { ListItem } from "@mui/material";

const markdown = `
# Terms and Conditions

## 1. Agreement to Terms
Welcome to **Let's Quit Drinking Together** ("the App"). By accessing or using our App, you agree to comply with and be bound by these Terms and Conditions. If you do not agree, you may not access or use the App.

## 2. Eligibility
You must be at least 18 years old to use the App. By using the App, you represent and warrant that you meet this eligibility requirement.

## 3. Account Registration
- All accounts are set to anonymous by default to protect user privacy.
- Users may modify anonymity settings via the profile options.
- You are responsible for maintaining the confidentiality of your account credentials and for all activities conducted under your account.

## 4. Prohibited Activities
You agree not to:
- Violate any applicable laws or regulations.
- Post abusive, harmful, or inappropriate content.
- Attempt to reverse-engineer, disrupt, or harm the App’s functionality.

## 5. Content Ownership
- Users retain ownership of the content they post.
- By posting content, you grant the App a non-exclusive, royalty-free license to use, display, and distribute your content within the platform.

## 6. Subscription and Billing
- Subscriptions are billed through the App Store or Play Store.
- Refunds are not offered for any subscription level.
- Canceling your subscription will deactivate your account and delete your data within 7-10 business days, unless an expedited deletion is requested.

## 7. Termination of Use
We reserve the right to terminate or suspend your account at any time for any violation of these Terms.

## 8. Privacy Policy
Your use of the App is also governed by our [Privacy Policy](#).

## 9. Limitation of Liability
The App is provided "as is" without warranties of any kind. We are not liable for any damages arising from your use of the App.

## 10. Changes to Terms
We may update these Terms at any time. Continued use of the App following such changes constitutes your agreement to the revised Terms.

## 11. Contact Us
For questions or concerns about these Terms, contact us at [support@knitbucket.com](mailto:support@knitbucket.com).

`;

export default function TermsContent() {
	return (
		<Container
			id="privacy"
			sx={{
				pt: { xs: 25, sm: 25 },
				pb: { xs: 8, sm: 16 },
				position: "relative",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				gap: { xs: 3, sm: 6 },
			}}
		>
			<Grid
				container
				spacing={3}
				sx={{
					width: "100%",
				}}
			>
				<Markdown
					components={{
						// Use h2s instead of h1s
						h1(props) {
							const { node, ...rest } = props;
							return (
								<Grid item container>
									<Grid item>
										<Typography variant="h1" {...rest} />
									</Grid>
								</Grid>
							);
						},
						h2(props) {
							const { node, ...rest } = props;
							return (
								<Grid item container>
									<Grid item>
										<Typography variant="h2" {...rest} />
									</Grid>
								</Grid>
							);
						},
						h3(props) {
							const { node, ...rest } = props;
							return (
								<Grid item container>
									<Grid item>
										<Typography variant="h3" {...rest} />
									</Grid>
								</Grid>
							);
						},
						h4(props) {
							const { node, ...rest } = props;
							return (
								<Grid item container>
									<Grid item>
										<Typography variant="h4" {...rest} />
									</Grid>
								</Grid>
							);
						},
						h5(props) {
							const { node, ...rest } = props;
							return (
								<Grid item container>
									<Grid item>
										<Typography variant="h5" {...rest} />
									</Grid>
								</Grid>
							);
						},
						h6(props) {
							const { node, ...rest } = props;
							return (
								<Grid item container>
									<Grid item>
										<Typography variant="h6" {...rest} />
									</Grid>
								</Grid>
							);
						},
						p(props) {
							const { node, ...rest } = props;
							return (
								<Grid item container>
									<Grid item>
										<Typography variant="body1" {...rest} />
									</Grid>
								</Grid>
							);
						},
						li(props) {
							const { node, children, ...rest } = props;
							return (
								<Grid item container alignItems={"center"}>
									<Grid item xs={false}>
										&bull;
									</Grid>
									<Grid item xs>
										<ListItem variant="body1" {...rest}>
											<Typography variant="body1">
												{children}
											</Typography>
										</ListItem>
									</Grid>
								</Grid>
							);
						},
					}}
				>
					{markdown}
				</Markdown>
			</Grid>
		</Container>
	);
}
